export default __webpack_public_path__ + "static/media/other28.979408f6.webp";